import { connect } from "react-redux";

import RoutePage from "./RoutePage";

export default connect((state) => {
  return {
    profile: state.auth.profile,
  };
}, {})(RoutePage);
